<script>
import useVuelidate from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

import appConfig from "@/app.config";
import AuthLayer from "@/router/views/account/AuthLayer";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {AuthLayer},
  page: {
    title: "Password Reset Request",
    meta: [{ name: "description", content: appConfig.description }],
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
    };
  },
  computed: {
    ... mapGetters({
      authLoading: 'authentication/authLoading',
      authErrors: 'authentication/authErrors'
    }),
  },
   methods: {
     ... mapActions({
       requestPasswordChange: 'authentication/requestPasswordChange'
     }),
    async tryToReset() {
      this.submitted = true;

      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      await this.requestPasswordChange({email: this.email})

      this.v$.$touch();
    },
  },
  validations () {
    return {
      email: {
        required,
        email,
      }
    }
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <AuthLayer>
    <div>
      <div>
        <h1 class="text-primary">Reset Password</h1>
        <h4 class="text-dark">Enter your Email and instructions will be sent to you!</h4>
      </div>

      <div class="mt-4">
        <form @submit.prevent="tryToReset">
          <b-alert
              v-model="isResetError"
              class="mb-4"
              variant="danger"
              dismissible
          >{{ error }}</b-alert
          >
          <div class="my-3">
            <label for="useremail" class="h5">Email</label>
            <input
                type="email"
                v-model="email"
                class="form-control py-3"
                id="useremail"
                placeholder="Enter email"
                :class="{ 'is-invalid': submitted && v$.email.$error }"
            />
            <p
                v-for="error of v$.email.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>

          <div v-for="(error, index) in authErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>

          <div class="mt-3 d-grid">
            <b-button variant="primary" size="lg" v-if="authLoading" disabled>
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button v-else variant="primary" size="lg" class="py-3 h3 text-white" type="submit"
            >Reset</b-button
            >
          </div>
        </form>
        <div class="mt-5 text-center h5">
          <p>
            Remember It ?
            <router-link
                to="/"
                class="fw-medium text-primary"
            >
              Log In</router-link
            >
          </p>
        </div>
      </div>
    </div>
  </AuthLayer>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
